import { t } from "i18next";

export const getSportColor = (sport: string) => {
    switch (sport) {
      case "MMA":
        return "danger";
      case "BOXING":
        return "warning";
      case "MUAY_THAI":
        return "secondary";
      case "JIU_JITSU":
        return "primary";
      case "KICKBOXING":
        return "success";
      case "WRESTLING":
        return "default";
      default:
        return "default";
    }
  };

  export const getPurseInfo = (purse: string) => {
      switch (purse) {
        case "BELOW_2000":
          return { color: "default" as const, text: t("purse_below_2000") };
        case "BELOW_5000":
          return { color: "primary" as const, text: t("purse_below_5000") };
        case "BELOW_10000":
          return { color: "secondary" as const, text: t("purse_below_10000") };
        case "ABOVE_10000":
          return { color: "success" as const, text: t("purse_above_10000") };
        default:
          return { color: "default" as const, text: purse };
      }
    };
  
    export const getCurrencySymbol = (currency: string) => {
      switch (currency) {
        case "USD":
          return "$";
        case "EUR":
          return "€";
        case "GBP":
          return "£";
        case "OTHER":
          return "";
        default:
          return currency;
      }
    };
  
    export const formatPurseText = (purse: string | number) => {
      const purseStr = typeof purse === 'string' ? purse : String(purse || 0);
      return purseStr
        .toLowerCase()
        .replace(/_/g, " ")
        .replace(/\b\w/g, (l) => l.toUpperCase());
    };

